import { CalendarRange } from "lucide-react";
import PageHeader from "@/layout/PageHeader";

export default function MonthlyBrief() {
  return (
    <div data-testid="monthly-brief-page">
      <PageHeader title="Monthly Brief" subtitle="Coming soon." />
      <div className="hm-surface p-12 text-center" data-testid="monthly-brief-empty">
        <CalendarRange className="h-6 w-6 text-hm-fg-subtle mx-auto mb-3" />
        <div className="text-sm text-hm-fg-muted">
          The 30-day executive digest — themes, momentum shifts, and Beyond
          Activ opportunities in one page. Not wired yet.
        </div>
      </div>
    </div>
  );
}
